// extracted by mini-css-extract-plugin
export var columnList = "_dj-0";